export default __webpack_public_path__ + "static/media/btg.69ff3236.png";